import React, { useState } from 'react';
import shade from '../../utils/shade';
import useConfigStore from '../../stores/configStore';
import getStyles from '../../utils/getStyles';
import QuoteInfo from '../Tabs/QuoteInfo/QuoteInfo';
import UserIcon from '../icons/UserIcon';
import MoneyMinusIcon from '../icons/MoneyMinusIcon';
import MoneyTagIcon from '../icons/MoneyTagIcon';
import MoneyWalletIcon from '../icons/MoneyWalletIcon';
import Coverages from '../Tabs/Coverages/Coverages';

export default function PolicyPurchaseConfirmation({
  quoteId,
  insuranceProvider = 'WTW',
  quoteExpense,
  quoteIPT,
  quoteTotalAmount,
  latestQuote,
  setIsBrizaPayment,
}) {
  const { style } = useConfigStore();
  const { primaryColor, theme } = style;
  const [selectedPaymentOption, setSelectedPaymentOption] = useState(null);

  return (
    <div
      className={`rounded-3xl mt-30 pb-8 pt-4 bg-backgroundColor text-textColor my-2 flex flex-col h-full items-center justify-start px-3 sm:mx-2 sm:px-1`}
    >
      <div className="flex flex-col items-center justify-start w-full px-2 sm:mt-6 sm:px-0">
        <span className="text-2xl sm:text-3xl font-bold text-center w-full mb-3 sm:mb-4">
          Your Insurance Quote
        </span>
        <div className="flex items-center text-base sm:text-lg">
          {/* <span className="px-2 break-all">{quoteId}</span> */}
          <div className="flex items-center gap-x-2 px-2">
            <UserIcon />
            <span className="capitalize">{insuranceProvider}</span>
          </div>
        </div>

        {['hiscox', 'brizaunifiedhiscox'].includes(
          insuranceProvider?.toLocaleLowerCase(),
        ) && latestQuote.collectPayment ? (
          <div className="w-full mt-6 sm:mt-8 px-2 sm:px-4">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-4 max-w-4xl mx-auto">
              {latestQuote.paymentOptions
                ? latestQuote.paymentOptions
                    .map((option) => ({
                      ...option,
                      label:
                        option.installmentNumberOfTimes === 0
                          ? 'Pay in full'
                          : option.installmentFrequency
                              .charAt(0)
                              .toUpperCase() +
                            option.installmentFrequency.slice(1),
                      description:
                        option.installmentNumberOfTimes === 0
                          ? 'Single payment - Best value'
                          : `${
                              option.installmentNumberOfTimes + 1
                            } payments per year`,
                    }))
                    .map((option, index) => (
                      <button
                        key={index}
                        className={`relative rounded-xl border-2 p-4 md:p-6 cursor-pointer transition-all duration-200 hover:shadow-lg ${
                          selectedPaymentOption === index
                            ? 'border-primary'
                            : 'border-gray-200 hover:border-primary'
                        }`}
                        onClick={() => setSelectedPaymentOption(index)}
                      >
                        {/* Selection indicator */}
                        <div
                          className={`absolute right-3 top-3 w-5 h-5 md:w-6 md:h-6 rounded-full border-2 flex items-center justify-center ${
                            selectedPaymentOption === index
                              ? 'border-primary'
                              : 'border-gray-300'
                          }`}
                        >
                          {selectedPaymentOption === index && (
                            <div className="w-2.5 h-2.5 md:w-3 md:h-3 rounded-full bg-primary" />
                          )}
                        </div>

                        {/* Payment option content */}
                        <div className="space-y-4">
                          <div>
                            <h3 className="text-base md:text-lg font-bold text-primary">
                              {option.label}
                            </h3>
                            <p className="text-xs md:text-sm text-gray-600">
                              {option.description}
                            </p>
                          </div>

                          <div className="space-y-2">
                            <div className="flex justify-between items-center">
                              <span className="text-xs md:text-sm">
                                Initial payment
                              </span>
                              <span className="font-semibold">
                                ${parseFloat(option.downpayment).toFixed(2)}
                              </span>
                            </div>

                            {option.installmentPayment !== '0.0000' && (
                              <div className="flex justify-between items-center">
                                <span className="text-xs md:text-sm">
                                  {option.installmentNumberOfTimes} payments of
                                </span>
                                <span className="font-semibold">
                                  $
                                  {parseFloat(
                                    option.installmentPayment,
                                  ).toFixed(2)}
                                </span>
                              </div>
                            )}
                          </div>

                          {/* <button
                      className={`w-full py-2 px-4 rounded-lg transition-all duration-200 ${
                        selectedPaymentOption === index
                          ? 'bg-primary text-white'
                          : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                      }`}
                      onClick={(e) => {
                        e.stopPropagation();
                        setSelectedPaymentOption(index);
                      }}
                    >
                      {selectedPaymentOption === index ? 'Selected' : 'Select'}
                    </button> */}
                        </div>
                      </button>
                    ))
                : null}
            </div>

            {selectedPaymentOption !== null && (
              <div className="mt-4 sm:mt-6 text-center">
                <button
                  className="bg-primary text-white py-3 px-5 sm:px-8 rounded-lg font-semibold hover:opacity-90 transition-opacity duration-200"
                  onClick={() => {
                    setIsBrizaPayment(
                      latestQuote.paymentOptions.map((option) => ({
                        ...option,
                        label:
                          option.installmentNumberOfTimes === 0
                            ? 'Pay in full'
                            : option.installmentFrequency
                                .charAt(0)
                                .toUpperCase() +
                              option.installmentFrequency.slice(1),
                        description:
                          option.installmentNumberOfTimes === 0
                            ? 'Single payment - Best value'
                            : `${
                                option.installmentNumberOfTimes + 1
                              } payments per year`,
                      }))[selectedPaymentOption],
                    );
                  }}
                >
                  Continue with selected plan
                </button>
              </div>
            )}
          </div>
        ) : (
          <div
            className="w-full rounded-2xl grid grid-cols-2 grid-rows-2 border-2 text-[#1F2751] mt-6 sm:flex sm:items-stretch sm:justify-between"
            style={{
              backgroundColor:
                theme == 'night'
                  ? shade(primaryColor, -0.7)
                  : shade(primaryColor, 0.9),
              borderColor:
                theme == 'night'
                  ? shade(primaryColor, -0.6)
                  : shade(primaryColor, 0.8),
            }}
          >
            <div className="w-full flex items-center gap-x-6 pl-7 py-3">
              <MoneyMinusIcon />
              <div className="flex flex-col items-start text-[16px] sm:text-lg">
                <span className="font-bold">${quoteExpense}</span>
                <span className="text-xs sm:text-sm">Yearly Premium</span>
              </div>
            </div>

            <div className="w-full flex items-center gap-x-6 pl-7 py-3">
              <div
                className="w-[2px] h-full"
                style={{
                  backgroundColor:
                    theme == 'night'
                      ? shade(primaryColor, -0.6)
                      : shade(primaryColor, 0.8),
                }}
              />
              <MoneyTagIcon />
              <div className="flex flex-col items-start text-[16px] sm:text-lg">
                <span className="font-bold">${quoteIPT}</span>
                <span className="text-xs sm:text-sm">IPT</span>
              </div>
            </div>

            <div className="w-full flex items-center justify-center gap-x-6 py-3 bg-primary rounded-b-2xl text-white col-span-2 sm:rounded-2xl sm:justify-start sm:pl-7">
              <MoneyWalletIcon />
              <div className="flex flex-col items-start text-[16px] sm:text-lg">
                <span className="font-bold">${quoteTotalAmount}</span>
                <span className="text-xs sm:text-sm">Total Payable Amount</span>
              </div>
            </div>
          </div>
        )}
      </div>
      {!['hiscox', 'brizaunifiedhiscox'].includes(
        insuranceProvider?.toLowerCase(),
      ) && (
        <div className="w-full mt-16">
          <Coverages
            showHeader={false}
            showCoverages={
              !['hiscox', 'brizaunifiedhiscox'].includes(
                insuranceProvider?.toLowerCase(),
              )
            }
          />
        </div>
      )}
    </div>
  );
}
